module.exports = __webpack_public_path__ + "assets/img/KeyReport_001.7f6b473b-ps.jpg";